module.exports = __webpack_public_path__ + "static/img/10.dff5ee9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/10.png
// module id = n/x3
// module chunks = 0